import React from "react";
import { motion } from "framer-motion";
import { ASSETS } from "../lib/api";
import { useT } from "../i18n/LanguageContext";

export const Convivialita = () => {
  const { t } = useT();
  const x = t.convivialita;
  return (
    <section className="relative overflow-hidden" data-testid="convivialita-section">
      <div className="absolute inset-0">
        <img src={ASSETS.terrazza} alt="" className="w-full h-full object-cover kenburns" />
        <div className="absolute inset-0 bg-gradient-to-b from-[var(--pn-black)]/95 via-[var(--pn-black)]/65 to-[var(--pn-black)]" />
        <div className="absolute inset-0 bg-gradient-to-r from-[var(--pn-black)]/95 via-[var(--pn-black)]/70 to-[var(--pn-black)]/20" />
        <div className="absolute inset-0 grain pointer-events-none" />
      </div>
      <div className="relative section-pad max-w-[1280px] mx-auto">
        <motion.span
          initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }}
          transition={{ duration: 0.7 }} className="eyebrow"
          style={{ textShadow: "0 2px 14px rgba(0,0,0,0.85)" }}
        >
          {x.eyebrow}
        </motion.span>
        <motion.h2
          initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
          transition={{ duration: 1.1, ease: [0.22, 0.61, 0.36, 1] }}
          className="mt-6 font-display font-light text-[44px] sm:text-[62px] md:text-[86px] lg:text-[104px] leading-[0.98] tracking-[-0.015em] text-[var(--pn-milk)] max-w-[14ch]"
          style={{ textShadow: "0 4px 28px rgba(0,0,0,0.9), 0 2px 8px rgba(0,0,0,0.7)" }}
        >
          {x.title_a}<em className="italic text-[var(--pn-amber)]">{x.title_b}</em>
        </motion.h2>
        <motion.div
          initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
          transition={{ delay: 0.3, duration: 1 }}
          className="mt-12 max-w-[680px] space-y-6"
        >
          <p
            className="text-[20px] md:text-[24px] leading-[1.6] text-[var(--pn-milk)] font-light"
            style={{ textShadow: "0 2px 18px rgba(0,0,0,0.85), 0 1px 4px rgba(0,0,0,0.7)" }}
          >
            {x.p1}
          </p>
          <p
            className="text-[18px] md:text-[21px] leading-[1.7] text-[var(--pn-cream)]/95 font-light"
            style={{ textShadow: "0 2px 16px rgba(0,0,0,0.85), 0 1px 4px rgba(0,0,0,0.65)" }}
          >
            {x.p2}
          </p>
        </motion.div>
      </div>
    </section>
  );
};
